// ## Functionality
// This script adds a click event listener to elements with the attribute `[data-name="sidebar-menu-item"]`. When clicked, it scrolls the element with the attribute `[data-name="side-bar-scroller"]` into view.

// ## Usage
// 1. Include this script in your HTML file.
// 2. Ensure elements with `[data-name="sidebar-menu-item"]` exist in your document.
// 3. Ensure an element with `[data-name="side-bar-scroller"]` exists to scroll into view.

// ## Notes
// - Make sure the elements with the specified data attributes exist in the DOM for the script to work correctly.

(function () {
  const sidebarMenuItem = document.querySelectorAll('[data-name="sidebar-menu-item"]');

  function scrollToTopWhenOpenSubmenu() {
    document.querySelector('[data-name="side-bar-scroller"]').scrollIntoView({ block: "end", inline: "start" });
  }

  sidebarMenuItem.forEach(el => el.addEventListener("click", scrollToTopWhenOpenSubmenu))
})();